module.exports = __webpack_public_path__ + "img/Cora.36e4865.png";